import { useQuery } from "@tanstack/react-query";
import { getLogs } from "./api";
import { reactQueryCacheAndRefetchOptions } from "@";

// Query keys for React Query
export const logsKeys = {
  all: ["logs"],
  list: (params) => [...logsKeys.all, "list", params],
};

// Query hook for fetching logs list
export const useLogsQuery = (params) => {
  return useQuery({
    queryKey: logsKeys.list(params),
    queryFn: async () => {
      const { data } = await getLogs(
        params?.page,
        params?.perSize,
        params?.search,
      );
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
};
